import { HiringManagerAggregation } from '@shared';

export interface HiringManagerCandidatesTotals {
  inReview: number;
  advanced: number;
  rejected: number;
}

export function createHiringManagerTotals(aggregation: HiringManagerAggregation = null) {
  return {
    inReview: !!aggregation ? aggregation.submitted : 0,
    advanced: !!aggregation ? aggregation.advanced : 0,
    rejected: !!aggregation ? aggregation.rejected : 0,
  } as HiringManagerCandidatesTotals;
}
